import {ContactATRECQStatusEnum} from '../../../schema-types/globalTypes';
import {themeColors} from '../../../theme/Theme';

// Color schemes for status chips used across Annual Reviews pages
export const atrEcqStatusColors: Record<ContactATRECQStatusEnum, string> = {
  [ContactATRECQStatusEnum.IN_DATE]: themeColors.lightYellow,
  [ContactATRECQStatusEnum.UP_TO_DATE]: themeColors.lightGreen,
  [ContactATRECQStatusEnum.SENT]: themeColors.lightBlue,
  [ContactATRECQStatusEnum.OUTDATED]: themeColors.lightAlert,
  [ContactATRECQStatusEnum.MISSING]: themeColors.lightAlert,
};
